module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/anastasi17-avatar-a4052d0cc8e26ac7aae4a19be80c9291.jpg";